import React, { Component, useContext } from 'react';
import { Layout, PageHeader, Spin, Card, Row, Col, Typography, Tabs, Button, Breadcrumb, message } from 'antd';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import usePermissions from '../../../Hooks/usePermissions';
import Logged from '../../../Hooks/Logged';
import CustomAvatar from '../../Widgets/Avatar/Avatar';
import { IconArrowBack } from '../../Widgets/Iconos';
import ModalTransaccion from '../Finanzas/Transacciones/ModalTransaccion';
import ModalTransaccionDetalle from '../Finanzas/Transacciones/ModalTransaccionDetalle';
import TransaccionesProyectoTab from './Secciones/TransaccionesProyectoTab';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;
const { TabPane } = Tabs;

class DetallesProyectos extends Component {
    state = {
        loading: false,
        proyecto_id: this.props.params.proyecto_id,
        proyecto: null,
        modalTransaccionVisible: false,
        modalTransaccionDetalleVisible: false,
        transaccion_id: undefined,
    }

    transaccionesRef = React.createRef()

    componentDidMount() {
        this.getProyecto()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.proyecto_id !== this.props.params.proyecto_id) {
        this.setState({ proyecto_id: this.props.params.proyecto_id }, this.getProyecto)
        }
    }

    getProyecto = () => {
        this.setState({ loading: true })
        axios.get(`/proyectos/${this.state.proyecto_id}`)
        .then(({ data }) => this.setState({ proyecto: data?.proyecto ?? data })) 
        .catch(() => message.error('Error al obtener el proyecto'))
        .finally(() => this.setState({ loading: false }))
    }

    updateAll = () => {
        this.transaccionesRef.current?.get?.()
    }

    render() {
        const { proyecto, loading } = this.state

        const urlParams = proyecto ? new URL(axios.defaults.baseURL + "/proyectos/logo/" + proyecto._id) : null
        if (urlParams) {
            urlParams.searchParams.set("Authorization", sessionStorage.getItem("token"))
            urlParams.searchParams.set("name", proyecto.logo?.name)
        }

        return (
            <Spin spinning={loading}>
                <PageHeader
                    className="site-page-header custom-page-header"
                    backIcon={<IconArrowBack />}
                    onBack={() => this.props.navigate('/admin/proyectos')}
                    title={
                        <Breadcrumb className="breadcrumb-header">
                        <Breadcrumb.Item>
                            <Link to="/admin/proyectos">Proyectos</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {proyecto?.nombre ?? 'Detalles'}
                        </Breadcrumb.Item>
                        </Breadcrumb>
                    }
                />
                <Content className="admin-content content-bg pd-1">
                    <Row gutter={[16,16]}>
                        <Col span={24}>
                            {proyecto && (
                                <Card bordered>
                                    <Row align="middle" className='mb-1' gutter={[12, 12]}>
                                        <Col span={18}>
                                            <Title level={4} >Información del Proyecto</Title>
                                        </Col>
                                    </Row>
                                    <Row >
                                        <Col xs={12} lg={8} xl={6}>
                                            <Paragraph>Nombre</Paragraph>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'baseline',
                                                    gap: 5,
                                                    lineHeight: 1,
                                                }}
                                            >
                                                <CustomAvatar
                                                    size={20}
                                                    color={proyecto.color}
                                                    style={{ marginTop: 1 }}
                                                    {...(proyecto.logo ? { image: urlParams.href } : { name: proyecto.nombre })}
                                                />
                                                <Paragraph strong style={{ fontSize: 16, margin: 0, lineHeight: '1.2em' }}>
                                                    {proyecto?.nombre}
                                                </Paragraph>
                                            </div>
                                        </Col>

                                        <Col  xs={12} lg={8} xl={6}>
                                            <Paragraph>Descripción</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16 }}>{proyecto?.descripcion}</Paragraph>
                                        </Col>

                                        <Col  xs={12} lg={8} xl={6}>
                                            <Paragraph>Dirección</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16 }}>{proyecto?.direccion}</Paragraph>
                                        </Col>

                                        <Col  xs={12} lg={8} xl={6}>
                                            <Paragraph>Ciudad</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16 }}>{proyecto?.ciudad}</Paragraph>
                                        </Col>

                                        <Col  xs={12} lg={8} xl={6}>
                                            <Paragraph>Estado</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16 }}>{proyecto?.estado}</Paragraph>
                                        </Col>

                                        <Col  xs={12} lg={8} xl={6}>
                                            <Paragraph>Razón Social</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16 }}>{proyecto?.razon_social}</Paragraph>
                                        </Col>

                                        <Col xs={12} lg={8} xl={6}>
                                            <Paragraph>URL del Proyecto</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16, marginBottom: 0 }}>
                                                <a
                                                    href={proyecto.url.startsWith('http') ? proyecto.url : `https://${proyecto.url}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#1677ff',
                                                        textDecoration: 'underline',
                                                        display: 'inline-block',
                                                        maxWidth: '100%',           
                                                        whiteSpace: 'nowrap',       
                                                        overflow: 'hidden',       
                                                        textOverflow: 'ellipsis',
                                                        verticalAlign: 'middle',
                                                    }}
                                                    title={proyecto.url}
                                                >
                                                    {proyecto.url}
                                                </a>
                                            </Paragraph>
                                        </Col>

                                        <Col  xs={12} lg={8} xl={6}>
                                            <Paragraph>Representante Legal</Paragraph>
                                            <Paragraph strong style={{ fontSize: 16 }}>{proyecto?.representante_id.nombre} {proyecto?.representante_id?.apellidos}</Paragraph>
                                        </Col>

                                        <Col xs={12} lg={8} xl={6}>
                                            <Paragraph>Firma del Representante</Paragraph>
                                            {proyecto?.firma?.file ? (
                                                <a
                                                    href={`${axios.defaults.baseURL}/proyectos/firma/${proyecto._id}?download=1&Authorization=${encodeURIComponent(sessionStorage.getItem("token"))}&name=${encodeURIComponent(proyecto.firma?.name || "")}`}
                                                >
                                                    {proyecto.firma.name}
                                                </a>
                                            ) : (
                                                <Text type="secondary">Sin Firma del Representante</Text>
                                            )}
                                        </Col>

                                        <Col xs={12} lg={8} xl={6}>
                                            <Paragraph>Imagen del Proyecto</Paragraph>
                                            {proyecto?.image?.name ? (
                                                <a
                                                    href={`${axios.defaults.baseURL}/proyectos/image/${proyecto._id}?download=1&Authorization=${encodeURIComponent(sessionStorage.getItem("token"))}&name=${encodeURIComponent(proyecto.image?.name || "")}`}
                                                >
                                                    {proyecto.image.name}
                                                </a>
                                            ) : (
                                                <Text type="secondary">Sin imagen de proyecto</Text>
                                            )}
                                        </Col>

                                    </Row>
                                </Card>
                            )}
                        </Col>

                        <Col span={24}>
                            <Tabs defaultActiveKey="transacciones" destroyInactiveTabPane>
                                <TabPane tab="Transacciones" key="transacciones">
                                    <TransaccionesProyectoTab
                                        ref={this.transaccionesRef}
                                        proyecto_id={this.state.proyecto_id}
                                        proyecto_info={proyecto}
                                        onOpenDetalle={(transaccion_id) => this.setState({ transaccion_id, modalTransaccionDetalleVisible: true })}
                                        onCreatedOrUpdated={this.updateAll}
                                        puedeCrear={this.props.crearTransaccionesProyecto}
                                    />
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>
                </Content>

                <ModalTransaccion
                    visible={this.state.modalTransaccionVisible}
                    onClose={() => { this.setState({ modalTransaccionVisible: false, transaccion_id: undefined }); this.updateAll() }}
                    transaccion_id={this.state.transaccion_id}
                    disabled={{ proyecto: true, cliente: true, propiedad: true, factura: true, inversion: true, acreedor: true }}
                    required={{ proyecto: true }}
                    initialValues={{
                        proyecto_id: proyecto ? { value: proyecto._id, label: proyecto.nombre } : null,
                        tipo: 1,
                    }}
                />

                <ModalTransaccionDetalle
                    visible={this.state.modalTransaccionDetalleVisible}
                    onClose={() => this.setState({ modalTransaccionDetalleVisible: false, transaccion_id: undefined })}
                    transaccion_id={this.state.transaccion_id}
                />
            </Spin>
        )
    }
}

export default function Wrapper() {
    const params = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const user = useContext(Logged)

    const permisos = usePermissions(user?.rol_id?.permisos, {
        verTransaccionesProyecto: ["proyectos", "transacciones", "access"],
        crearTransaccionesProyecto: ["proyectos", "transacciones", "create"],
    })

    return (
        <DetallesProyectos
            params={params}
            navigate={navigate}
            location={location}
            {...permisos}
        />
    )
}
